import React from 'react';
import { useIntl } from 'umi';

export default function EmptyValue() {
  const { formatMessage } = useIntl();
  return (
    <div className="dbi-cascader-select-button-placeholder">
      {formatMessage({ id: 'dbi_please_select_metrics' })}
    </div>
  );
}
